import type {User} from "account/User";
import {planOf} from "home/gating";

/** What a coupon dialog's Subscribe needs in order to continue through a sign-in. */
export interface FreeCheckoutPorts {
	/** The account as it is NOW, re-read after the sign-in rather than captured at the press. */
	user: () => User;
	/** Whether the dialog is still open for this visit. */
	active: () => boolean;
	/** Raises the sign-in, resolving true once the reader is signed in. */
	login: () => Promise<boolean>;
	/** Starts the checkout; called at most once, only when every check above still passes. */
	start: () => Promise<void>;
}

/**
 * Subscribe on a coupon dialog a reader may reach signed out: the promo link (kitecorp/transferify-ui#2343)
 * and the limit-wall email (kitecorp/transferify-api-service#2206).
 *
 * The sign-in's result is not permission to buy: it may have signed in an account that already pays, and
 * the reader may have closed the dialog while the modal was up. Both are asked again after it.
 */
export async function resumeFreeCheckout(ports: FreeCheckoutPorts): Promise<void> {
	if (!ports.active()) return;
	if (!ports.user().isLoggedIn && !await ports.login()) return;
	if (!ports.active() || !ports.user().isLoggedIn || planOf(ports.user()) !== "free") return;
	await ports.start();
}
